module.exports = __webpack_public_path__ + "img/pantalla2-3.1bcdbfb4.png";